export default "__VITE_ASSET__dc1tc3MI__"